export default "__VITE_ASSET__uTZB66GF__"